import { IframeLoadFailedError, IframeLoadErrorCode } from '@fluidx/office-fluid-types';
import { InitializeIframeMethodName } from '../Constants';
import { loadComponentInSourcelessIframeGeneric } from './loadComponentInSourcelessIframeGeneric';
/**
 * The internal implementation of "loadComponentInSourcelessIframe".
 * Most of the parameters are just pass-through-s from the original public-facing call.
 */
export function loadComponentInSourcelessIframeInternal({ initializeConfig, dependencySynthesizer, hostContext, iframeHostingElement, config, options, additionalInfo }) {
    const initializeCallback = async (params, loadActivityTracker) => {
        // By the time the onload fired, and since it's a sourceless iframe, contentWindow is not null
        const iframeWindow = params.iframe.contentWindow;
        // Call the specially-exposed initialization method, that was exposed on the Inside of the iframe
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any
    -- TODO: Using 'any' type defeats the purpose of TypeScript. Consider replacing it with a concrete type, or 'unknown'. */
        const initMethod = iframeWindow[InitializeIframeMethodName];
        /* It is possible to have initMethod undefined if we fail to fetch the script that creates the method put on the window
        Related incident: https://portal.microsofticm.com/imp/v3/incidents/postmortem/582900 */
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!initMethod) {
            throw new IframeLoadFailedError('InitMethod is not defined on window', 
            /**internalError */ undefined, 
            /**ErrorCode */ IframeLoadErrorCode.UndefinedInitializeIframeMethod);
        }
        const loadResult = await initMethod(params);
        // Set up the loadActivityTracker to resolve once the container and component
        // have loaded -- but do NOT wait for it to complete:
        Promise.all([loadResult.component, loadResult.container])
            .then(() => loadActivityTracker.setResult(true))
            .catch((error) => loadActivityTracker.setResult(false, {}, error));
        return loadResult;
    };
    return loadComponentInSourcelessIframeGeneric({
        initializeConfig,
        iframeHostingElement,
        dependencySynthesizer,
        hostContext,
        config,
        options,
        additionalInfo,
        initializeCallback
    });
}
// cspell:ignore bootstrapper, prefetch, srcdoc, iframes, preconnect
//# sourceMappingURL=loadComponentInSourcelessIframeInternal.js.map